import '../plugins/SlickCarouselPlugin.js';
import '../plugins/ResponsiveHelper.js';

// slick init
export default function initSlickCarousel() {
	var $mobSliderPlaceholder = jQuery('.mobile-location-slider-placeholder');
	var $desktopSliderPlaceholder = jQuery('.desktop-location-slider-placeholder');

	jQuery('.holder-gallery').each(function () {
		var $holder = jQuery(this);
		var $slider = $holder.find('.custom-gallery');
		var $dots = $holder.find('.dots-placeholder');

		$slider.slick({
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			infinite: true,
			waitForAnimate: true,
			fade: true,
			appendDots: $dots,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
		});
    $dots.find('li').each(function(index) {
      var $dot = $(this);
      if (index === 0) {
        setTimeout(() => {
          $dot.addClass('slick-current');
        }, 100);
      }
    });
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $dots.find('li').each(function(index) {
        var $dot = $(this);
        $dot.removeClass('slick-current');
        $dot.removeClass('slick-done');
        if (index < nextSlide) {
          $dot.addClass('slick-done');
        }
        if (index === nextSlide) {
          setTimeout(() => {
            $dot.addClass('slick-current');
          }, 100);
        }
      });
    });
	});

	jQuery('[data-slider-for]').each(function() {
		var $holder = jQuery(this);
		var $items = $holder.find('.location-item');
		var $slider = jQuery($holder.data('sliderFor'));

		if (!$slider.length) return;

		function slickGoTo(e) {
			var index = jQuery(e.currentTarget).index();

			try {
				$slider.slick('slickGoTo', index);

				ResponsiveHelper.addRange({
					'..1024': {
						on: function() {
							if (e && e.type === 'click') {
								jQuery('html, body').stop().animate({ scrollTop: $slider.offset().top - 60 }, 800);
							}
						}
					}
				});
			} catch(e) {}
		}

		$items.on('click', slickGoTo);
		$slider.on('afterChange', function(e, slick, currentSlide) {
			$items.removeClass('active-location').eq(currentSlide).addClass('active-location');
		});
	});

	jQuery('.main-gallery').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M17.955 2.295l-13.475 13.713 13.474 13.712-2.246 2.285-15.718-15.998 15.719-15.998z"></path></svg></button>',
		nextArrow: '<button class="slick-next"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M0.187 29.544l13.010-13.539-13.010-13.537 2.167-2.258 15.179 15.794-15.179 15.796z"></path></svg></button>',
		dots: true,
		dotsClass: 'slick-dots',
		centerMode: true,
		centerPadding: '0px',
		responsive: [{
			breakpoint: 768,
			settings: {
				arrows: false
			}
		}]
	});

	jQuery('.main-gallery--container').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M172.9 432.2L2.355 261.7c-3.14-3.14-3.14-8.226 0-11.37l170.5-170.5c3.14-3.14 8.226-3.14 11.37 0s3.14 8.226 0 11.37L27.44 247.1h412.5c4.427 0 8.036 3.597 8.036 8.04s-3.61 8.035-8.036 8.035H27.44l156.8 156.8c3.14 3.14 3.14 8.226 0 11.37C181.1 435.3 175.1 435.3 172.9 432.2z"/></svg></button>',
		nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M275.1 79.82l170.5 170.5c3.14 3.14 3.14 8.226 0 11.37l-170.5 170.5c-3.14 3.14-8.226 3.14-11.37 0c-3.14-3.14-3.14-8.226 0-11.37l156.8-156.8H8.037c-4.427 0-8.036-3.593-8.036-8.036s3.609-8.039 8.036-8.039h412.5l-156.8-156.8c-3.14-3.14-3.14-8.226 0-11.37C266.9 76.68 272 76.68 275.1 79.82z"/></svg></button>',
		dots: true,
		dotsClass: 'slick-dots',
		centerMode: true,
		centerPadding: '0px',
    infinite: false,
    cssEase: 'ease-in-out',
    speed: 1500,
	});

	jQuery('.main-gallery--text').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M17.955 2.295l-13.475 13.713 13.474 13.712-2.246 2.285-15.718-15.998 15.719-15.998z"></path></svg></button>',
		nextArrow: '<button class="slick-next"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M0.187 29.544l13.010-13.539-13.010-13.537 2.167-2.258 15.179 15.794-15.179 15.796z"></path></svg></button>',
		dots: true,
		dotsClass: 'slick-dots',
		centerMode: true,
		centerPadding: '0px',
		responsive: [{
			breakpoint: 768,
			settings: {
				arrows: false
			}
		}]
	});

  jQuery('.collections-holder').slick({
    slidesToScroll: 1,
    slidesToShow: 4,
    rows: 0,
    prevArrow: '<button class="slick-prev"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M17.955 2.295l-13.475 13.713 13.474 13.712-2.246 2.285-15.718-15.998 15.719-15.998z"></path></svg></button>',
    nextArrow: '<button class="slick-next"><svg version="1.1" width="18" height="32" viewBox="0 0 18 32" fill="currentColor"><path d="M0.187 29.544l13.010-13.539-13.010-13.537 2.167-2.258 15.179 15.794-15.179 15.796z"></path></svg></button>',
    dots: false,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 1,
      }
    }]
  });

	ResponsiveHelper.addRange({
		'..1023': {
			on: function() {
				$desktopSliderPlaceholder.children(true).appendTo($mobSliderPlaceholder);
			}
		},
		'1024..': {
			on: function() {
				$mobSliderPlaceholder.children(true).appendTo($desktopSliderPlaceholder);
			}
		}
	});

	jQuery('.cards-gallery').slick({
		slidesToScroll: 1,
		slidesToShow: 3,
		rows: 0,
		infinite: false,
		prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512" data-livestyle-extension="available" style="transform: rotate(180deg);"><path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"/></svg></button>',
		nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512" data-livestyle-extension="available"><path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"/></svg></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 2
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 1
			}
		}]
	});

	jQuery('.artworks-gallery').slick({
		slidesToScroll: 1,
		slidesToShow: 5,
		rows: 0,
		prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>',
		nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path d="M85.14 475.8c-3.438-3.141-5.156-7.438-5.156-11.75c0-3.891 1.406-7.781 4.25-10.86l181.1-197.1L84.23 58.86c-6-6.5-5.625-16.64 .9062-22.61c6.5-6 16.59-5.594 22.59 .8906l192 208c5.688 6.156 5.688 15.56 0 21.72l-192 208C101.7 481.3 91.64 481.8 85.14 475.8z"/></svg></button>',
		dotsClass: 'slick-dots',
		variableWidth: false,
		responsive: [{
			breakpoint: 1024,
			settings: {
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 1,
				variableWidth: true
			}
		}]
	});

  jQuery('.press-release-slider').slick({
    slidesToScroll: 1,
    slidesToShow: 3,
    rows: 0,
    prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>',
    nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path d="M85.14 475.8c-3.438-3.141-5.156-7.438-5.156-11.75c0-3.891 1.406-7.781 4.25-10.86l181.1-197.1L84.23 58.86c-6-6.5-5.625-16.64 .9062-22.61c6.5-6 16.59-5.594 22.59 .8906l192 208c5.688 6.156 5.688 15.56 0 21.72l-192 208C101.7 481.3 91.64 481.8 85.14 475.8z"/></svg></button>',
    dots: false,
    infinite: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
}
